import styled from 'styled-components';
import {getToken, getFontSize, getFontWeight, getPrimitive} from '@tickchak/react-share/app';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export type BadgeVariant = 'error' | 'warning' | 'success' | 'successBg';

const STATUS_COLORS: Record<BadgeVariant, string> = {
    error: getToken('color.state.error.main'),
    warning: getToken('color.state.warning.main'),
    success: getToken('color.state.success.main'),
    successBg: getToken('color.state.success.bg'),
};

export const status = styled.div<{variant: BadgeVariant}>`
    ${dFlexCenter};
    gap: var(--space-sm);
    color: ${p => STATUS_COLORS[p.variant]};
    font-size: ${getFontSize('bodySmall')};
    font-weight: ${getFontWeight('bold')};
    line-height: 1.2;
    text-align: end;
    padding-inline-start: var(--space-lg);
    padding-inline-end: var(--space-sm);
    padding-block: var(--space-sm);
`;

export const statusText = styled.span<{variant: BadgeVariant}>`
    color: ${p => STATUS_COLORS[p.variant]};
    white-space: nowrap;
`;

export const statusCounter = styled.span<{variant: BadgeVariant}>`
    ${dFlexCenter};
    gap: var(--space-xs);
    color: ${p => STATUS_COLORS[p.variant]};
    white-space: nowrap;
`;

export const statusIcon = styled.span<{variant: BadgeVariant}>`
    ${dFlexCenter};
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('caption')};
    flex-shrink: 0;
    background-color: ${p => p.variant === 'success' ? STATUS_COLORS.successBg : STATUS_COLORS[p.variant]};
    color: ${getPrimitive('color.bg.surface.default')};
`;

export const characters = styled.span<{variant: BadgeVariant}>`
    color: ${p => STATUS_COLORS[p.variant]};
    font-weight: ${getFontWeight('regular')};
`;